module.exports = __webpack_public_path__ + "static/img/dress_casual_button.68fb287c.jpg";